import type {
  CertificateLike,
  ProgressLike,
  XapiContext,
  XapiServiceLike,
} from '@efdigital/ll-addon-content/types/services/xapi-like';
import Service from '@ember/service';

/**
 * Stub xAPI service for ll-admin-v2
 * This application doesn't track xAPI progress, but some components
 * (like ResourceListing) expect this service to exist.
 */
export default class XapiService extends Service implements XapiServiceLike {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isPageComplete(_ctx: XapiContext): Promise<boolean> {
    return Promise.resolve(false);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getContentPackage(_id: string, _version: number): Promise<string> {
    return Promise.resolve('');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getCertificate(_type: string, _id: string): Promise<CertificateLike> {
    return Promise.resolve({
      date: '',
      license: '',
      evidence: '',
      badge: '',
      complete: false,
      statements: [],
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  sendStatements(_statements: unknown[]): void {
    // No-op in admin context
  }

  getContentPackageProgress(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _id: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _version: number | 'all'
  ): Promise<ProgressLike> {
    return Promise.resolve({
      packages: [],
      resource: {
        percent: 0,
      },
    });
  }
}
